/**
 * Reserved URL paths that cannot be used as usernames or matched by the
 * top-level /:username route. Used both server-side validation and
 * client-side link generation.
 */
export const RESERVED_USERNAMES = new Set([
  'about', 'admin', 'api', 'auth', 'crm', 'dashboard', 'embed-widget', 'explore',
  'favorites', 'features', 'feed', 'forgot-password', 'history', 'icon-preview', 'invite', 'investor',
  'library', 'login', 'messages', 'passcode', 'pay', 'payment', 'privacy_policy', 'products',
  'profile', 'receipt', 'register', 'request', 'requests', 'reset-password', 'seller-analytics',
  'send', 'settings', 'store', 'subscriptions', 'team', 'u', 'verify-email', 'wallet',
]);

/**
 * Build the canonical link to a user's public profile.
 * Prefers the clean /username path; falls back to /u/:userId for users
 * without a username set.
 */
export function profileLink(user) {
  if (!user) return '/';
  const username = (user.username || '').trim().toLowerCase();
  if (username && !RESERVED_USERNAMES.has(username)) {
    return `/${username}`;
  }
  return `/u/${user.user_id}`;
}
